"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faEllipsisH_1 = require("@fortawesome/pro-solid-svg-icons/faEllipsisH");
var faSlashForward_1 = require("@fortawesome/pro-solid-svg-icons/faSlashForward");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var SIZE_MAPPER = {
    small: 14, regular: 18, large: 24,
};
var SlashedMenu = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'regular' : _b, tooltipTitle = _a.tooltipTitle, rest = __rest(_a, ["size", "tooltipTitle"]);
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ variant: "dark", title: tooltipTitle || '', placement: "bottom", disableInteractive: true }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ component: "span", className: "fa-layers", sx: { color: 'neutral.main' } }, rest, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faEllipsisH_1.faEllipsisH, style: { fontSize: SIZE_MAPPER[size] } }), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faSlashForward_1.faSlashForward, style: { fontSize: SIZE_MAPPER[size] } })] })) })));
};
exports.default = SlashedMenu;
